export const SESSION_KEY = 'credit::shared::initial-path'

export const paths = {
  home: 'home',
  'loan-home': 'área de empréstimo',
  'loan-details': 'detalhes do empréstimo'
}

export type PathNameOptions = keyof typeof paths
